import * as React from 'react';
import styles from './Slide.module.css';
const Slide = ({ children, type }) => {
    return (React.createElement("div", { key: type, className: styles.slide }, children));
};
export default Slide;
//# sourceMappingURL=Slide.js.map